import history from '@utils/history';
import { useCallback, useMemo } from 'react';
import { useParamsContext } from '../params/params-context';
import { PORTAL_TYPE } from '../types/app.types';
import { ButtonListDataItem } from '../components/dispatch-page/buttons-list.data';

const useDispatchButton = (
  item: ButtonListDataItem
): { onClickHandler: () => void; isCurrentPortal: boolean } => {
  const { portalType } = useParamsContext();

  const isCurrentPortal = useMemo(
    () =>
      item.id === PORTAL_TYPE.ERDE ||
      item.id === PORTAL_TYPE.ER1 ||
      item.formRootPage === portalType,
    [item.formRootPage, item.id, portalType]
  );
  const onClickHandler = useCallback(() => {
    history.push(
      !isCurrentPortal
        ? {
            pathname: '/redirect',
            state: { redirectTo: item.formRootPage }
          }
        : item.link
    );
  }, [isCurrentPortal, item.formRootPage, item.link]);
  return { isCurrentPortal, onClickHandler };
};
export default useDispatchButton;
